/**
 * Lightweight Fade / Rotate stand-ins for the removed react-reveal package.
 */

import React from 'react'
import PropTypes from 'prop-types'

function directionClass(prefix, props) {
  if (props.top) return `${prefix}-top`
  if (props.bottom) return `${prefix}-bottom`
  if (props.left) return `${prefix}-left`
  if (props.right) return `${prefix}-right`
  if (props.up) return `${prefix}-up`
  return prefix
}

export function Fade({ children, delay = 0, big, className = ``, style, ...rest }) {
  const dir = directionClass(`reveal-fade`, rest)
  const classes = [`reveal`, dir, big ? `reveal-big` : ``, className].filter(Boolean).join(` `)
  return (
    <div className={classes} style={{ animationDelay: `${delay}ms`, ...style }}>
      {children}
    </div>
  )
}

Fade.propTypes = {
  children: PropTypes.node,
  delay: PropTypes.number,
  big: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  top: PropTypes.bool,
  bottom: PropTypes.bool,
  left: PropTypes.bool,
  right: PropTypes.bool,
  up: PropTypes.bool,
}

export function Rotate({ children, delay = 0, className = ``, style, ...rest }) {
  const classes = [`reveal`, `reveal-rotate`, className].filter(Boolean).join(` `)
  return (
    <div className={classes} style={{ animationDelay: `${delay}ms`, ...style }}>
      {children}
    </div>
  )
}

Rotate.propTypes = {
  children: PropTypes.node,
  delay: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  top: PropTypes.bool,
  right: PropTypes.bool,
}

export default Fade
